import React, { useState, useEffect } from 'react';
import { Stack, Text, TextField, Icon, Modal, IconButton, IIconProps, DialogFooter, DialogType, PrimaryButton, Dialog } from '@fluentui/react';
import { SearchIcon, Input, Avatar, Status, ChevronEndMediumIcon, ChevronDownIcon } from '@fluentui/react-northstar';
import copy from 'copy-to-clipboard';

import { Tabs } from 'antd';
import { AccessibleTab } from '../AccessibleAntdComponent';
import ChatHeader from '../../containers/ChatHeader';
import ChatArea from '../../containers/ChatArea';
import config from '../../config';
import NoClient from './NoClient';
import { getExpression } from '../../utils/utils';
import { ENTER_KEY } from '../../constants';

import Monitor from '../Monitor/Monitor';
import LogPage from '../LogPage';
import SetupPage from '../SetupPage/SetupPage';
import PersonalLogPage from '../PersonalLogPage/PersonalLogPage';
import { ThreadInfo } from '../../models/ChatStores';
import { apiServices } from '../../services/ApiServices';
import pubsub from 'pubsub-js';
import moment from 'moment';
import { ContextualMenu } from '@fluentui/react/lib/ContextualMenu';
import { Image, IImageProps, ImageFit } from '@fluentui/react/lib/Image';
import { useSelector } from 'react-redux';
import { analytics } from '../../utils/analytics';
import { getIsAuthenticated } from '../../selectors/getIsAuthenticated';

// styles and images
import {
  StartScreenContainerStyle,
  StartScreenSectionStyle,
  SideboxStyles,
  SideHeaderSerchStyle,
  tabStyles,
  chatAvatarStyle,
  listcopybtnStyle,
  textStyle,
  listLiStyle,
  mt,
  contentStyles,
  iconButtonStyles,
  textHeaderStyle,
  quickSaveStyle
} from '../styles/StartScreen/Startscreen.styles';
import img from '../../assets/Illustration.png';
require('../../styles/antd.css');

const cancelIcon: IIconProps = { iconName: 'Cancel' };
const { TabPane } = Tabs;

const imageProps: IImageProps = {
  maximizeFrame: true,
  imageFit: ImageFit.cover,
  src: img,
  // Show a border around the image (just for demonstration purposes)
  styles: (props) => ({ root: { width: '536px', height: '200px' } })
};
let chatThreadDeleted: NodeJS.Timeout;
let participantsRemoved: NodeJS.Timeout;
let chatThreadCreated: NodeJS.Timeout;
let participantsAdded: NodeJS.Timeout;
const dialogStyles = { main: { maxWidth: 450, width: "400px", borderRadius: "4px" }, scrollableContent: { width: "400px" } };
const dragOptions = {
  moveMenuItemText: 'Move',
  closeMenuItemText: 'Close',
  menu: ContextualMenu,
};

export default function StartScreen() {
  const [handleSearch, setHandlesearch] = useState(true);
  const [threads, setThreads] = useState<ThreadInfo[]>([]);
  const [threads2, setThreads2] = useState<ThreadInfo[]>([]);
  const [isBlock, setIsBlock] = useState(true);
  const [lastMessage, setLastMessage] = useState<any>();
  const [chatActive, setChatActive] = useState(true);
  const [placeholderText, setPlaceholderText] = useState('输入文字，快捷保存新知识');
  const [isBlockindex, setIsBlockindex] = useState<any>();
  const [categoryData, setCategoryData] = useState([]);
  const [categoryData2, setCategoryData2] = useState([]);
  const [activeIndex, setActiveIndex] = useState('');
  const [knowledgeText, setKnowledgeText] = useState('');
  const [isCopythis, setIsCopythis] = useState<any>(null);
  const [adminFncType, setAdminFncType] = useState<any>(0);
  const [HintDialogTitle, setHintDialogTitle] = useState('');
  const [HintDialogSubText, setHintDialogSubText] = useState('');
  const [isDraggable, setIsDraggable] = useState(false);
  const [hideDialog, setHideDialog] = useState(false);
  const modalProps = React.useMemo(
    () => ({
      isBlocking: true,
      styles: dialogStyles,
      dragOptions: isDraggable ? dragOptions : undefined,
    }),
    [isDraggable],
  );

    //知识库搜索方法
  const handleSearchValue = (e: any) => {
    let datalist = [...categoryData];
    let a: any = [];
    let newArr2: any = [
      {
        id: '',
        listItem: [],
        name: '搜索结果'
      }
    ];
    if (e.target.value !== '') {
      datalist.forEach((val: any) => {
        if (val.listItem?.length > 0) {
          let newArr = val.listItem.forEach((item: any) => {
            if (
              item.itemContent.toUpperCase().indexOf(e.target.value.toUpperCase()) !== -1 ||
              item.name.toUpperCase().indexOf(e.target.value.toUpperCase()) !== -1
            ) {
              newArr2[0].listItem.push(item);
              return item;
            }
          });
        }
      });
      //是否展开子项
      isBlockindex.forEach((item: any) => {
        a.push(true);
      });

      setIsBlockindex(a);
      //避免数据二次请求， 将请求的知识库列表保存在CategoryData，后续操作CategoryData2
      setCategoryData2(newArr2);
    } else {
      isBlockindex.forEach((item: any) => {
        a.push(false);
      });
      setIsBlockindex(a);
      setCategoryData2(categoryData);
    }
  };
  const touristName = (time: number) => {
    let createdTime = moment(time).format('YY/MM/DD');
    let todayTime = moment().format('YY/MM/DD');
    let name;
    if (todayTime === createdTime) {
      name = `今日 ${moment(time).format('LT')}`
    } else {
      if (moment().format('YY') === moment(time).format('YY')) {
        name = ` ${moment(time).format('MM/DD LT')}`
      } else {
        name = ` ${moment(time).format('YY/MM/DD LT')}`
      }
    }
    return name
  };
  const handleList = async (index: number) => {
    //点击展开闭合知识库列表
    isBlockindex[index] = !isBlockindex[index];
    setIsBlock(!isBlock);
  };

  const copyContent = (key: string) => {
    //复制知识库内容
    let text = document.getElementById(`${key}`)?.innerHTML;
    text && copy(text);
    setIsCopythis(key);
    setTimeout(() => {
      setIsCopythis(() => {
        return null;
      });
    }, 3000);
  };

  const handleRemove = (threadId: string, isTransfer?: boolean, isToMe?: boolean) => {
    loadPage();
  };
  const TabClick = (key: string) => {
    if (key !== 'title') {
      //当前选中项
      if (lastMessage && lastMessage.threadId === key) {
        setChatActive(false); //红色未读消息关闭
      }
      setActiveIndex(key);
    }
  };

  //请求历史记录，获取最后一次聊天时间
  const LoadHistoryMessages = async (appId: string, customerId: number) => {
    let Timestamp2 = moment(new Date()).format().replace('+', '%2B');
    let result = new Date();
    await apiServices.getHistoricalDialogue(appId, customerId, Timestamp2, 1).then((res) => {
      if (res.result?.length > 0) {
        let a = res.result.map((item: any) => {
          if (item.messageType === 'Text' || item.messageType === 'Image') {
            item.content = JSON.parse(item.content);
          }
        });
        result = res.result[0].content?.Timestamp;
      }
    });
    return result;
  };
  const ReverseRankingDate = (arr: any) => {
    //名称排序
    return arr.sort(function compareFunction(item1: any, item2: any) {
      return item1.displayName?.localeCompare(item2.displayName, 'zh-CN');
    });
  };

  const loadPage = async () => {
    //首次加载
    const acsToken = await apiServices.getSupportInfo(); //请求用户消息
    if (acsToken) {
      const newToken = await apiServices.getRefreshToken(acsToken?.cdsUserId || '');
      config.getChatClient(newToken?.token).then(async (client) => {
        const result = await apiServices.getChatThreadList(); //请求当前客服已接入的用户信息列表
        const result2 = await apiServices.activeInterveneTicket(); //请求当前客服已接入的用户信息列表
        let tempArr: any = [];
        let tempArr2: any = [];

        await Promise.all(
          [...result]?.map(async (item: any, index: number) => {
            let i = item.fromChannel.lastIndexOf(':');
            let appId: string = item.fromChannel.substring(i + 1, item.fromChannel.length); //截取appdi
            try {
              let chatThreadClient = client?.getChatThreadClient(item.toChannel); //client聊天室唯一用户实例，用于传给聊天组件
              let data = await LoadHistoryMessages(appId, item.creator.channelUserId);
              let time;
              if (moment(data).format('YY-MM-DD') === moment(new Date()).format('YY-MM-DD')) {
                time = moment(data).format('LT');
              } else {
                time = moment(data).format('MM/DD');
              }
              tempArr.push({
                threadId: item.toChannel,
                displayName: item.creator.displayName || `游客     ${touristName(item.createAt)}`,
                avatar: item.creator.userAvatar,
                chatThreadClient: chatThreadClient,
                lastMessage: '',
                date: time ? time : '',
                fromUserExtend: item.fromUserExtend,
                appId: appId,
                ticketId: item.id,
                customerId: item.creator.channelUserId,
                displayTicketId: item.displayTicketId
              });
            } catch (exception) {
              analytics.trackException(exception);            
            }
          })
        );
        await Promise.all(
          [...result2]?.map(async (item: any, index: number) => {
            let i = item.fromChannel.lastIndexOf(':');
            let appId: string = item.fromChannel.substring(i + 1, item.fromChannel.length); //截取appdi
            try {
              let chatThreadClient = client?.getChatThreadClient(item.toChannel); //client聊天室唯一用户实例，用于传给聊天组件
              let data = await LoadHistoryMessages(appId, item.creator.channelUserId);
              let time;
              if (moment(data).format('YY-MM-DD') === moment(new Date()).format('YY-MM-DD')) {
                time = moment(data).format('LT');
              } else {
                time = moment(data).format('MM/DD');
              }
              tempArr2.push({
                threadId: item.toChannel,
                displayName: item.creator.displayName || `游客     ${touristName(item.createAt)}`,
                avatar: item.creator.userAvatar,
                chatThreadClient: chatThreadClient,
                lastMessage: '',
                fromUserExtend: item.fromUserExtend,
                date: time ? time : '',
                appId: appId,
                ticketId: item.id,
                customerId: item.creator.channelUserId,
                displayTicketId: item.displayTicketId
              });
            } catch (exception) {
              analytics.trackException(exception);
            }
          })
        );
        setThreads2(ReverseRankingDate(tempArr2));
        setThreads(ReverseRankingDate(tempArr));
        TabClick(tempArr[0]?.threadId);
        client?.startRealtimeNotifications(); //启动实时通知
        client?.on('chatMessageReceived', (e) => {
          let msg;
          if (e.senderDisplayName === '45C218B5-0CF1-4703-8272-4E863528A1E7') {
            msg = JSON.parse(e.message).content;
          } else {
            let msgData = JSON.parse(e.message);
            if (msgData.MsgType == 0) {
              msg = msgData.Content;
            } else {
              msg = '[图片消息]';
            }
          }

          setLastMessage({
            threadId: e.threadId,
            message: getExpression(msg),
            date: moment(e.createdOn).format('LT')
          });

          setChatActive(true); //未读消息标识

          pubsub.publish(`message-${e.threadId}`, e);
        });

        client.on('chatThreadCreated', (e) => {
          console.log(e, 'chatThreadCreated');

          //新聊天创建
          chatThreadCreated = setTimeout(async () => {
            let List = await apiServices.getChatThreadList();
            let customer = List.length && List.filter((item: any) => item.toChannel === e.threadId);
            let customer2 = threads.filter((item: any) => item.threadId === e.threadId);
            if (customer && !customer2) {
              let i = customer[0].fromChannel.lastIndexOf(':');
              let appId: string = customer[0].fromChannel.substring(i + 1, customer[0].fromChannel.length);
              try {
                // const customerInfo = await apiServices.getUserInfo(customer[0].customerId, appId);
                let chatThreadClient = client?.getChatThreadClient(e.threadId);
                setThreads((s) => {
                  return [
                    ...s,
                    {
                      threadId: e.threadId,
                      displayName: customer[0].creator.displayName || `游客        ${touristName(customer[0].createAt)}`,
                      avatar: customer[0].creator.userAvatar,
                      chatThreadClient: chatThreadClient,
                      lastMessage: '',
                      fromUserExtend: customer[0].fromUserExtend,
                      date: moment(e.createdOn).format('LT'),
                      appId: appId,
                      ticketId: customer[0].id,
                      customerId: customer[0].creator.channelUserId,
                      displayTicketId: customer[0].displayTicketId
                    }
                  ];
                });
              } catch (exception) {
                analytics.trackException(exception);
              }
            }
          }, 3000);
        });
        //加入新成员
        client.on('participantsAdded', (e) => {
          console.log(e, 'participantsAdded');
          clearTimeout(participantsAdded);

          participantsAdded = setTimeout(async () => {
            const List = await apiServices.getChatThreadList();
            try {
              let chatThreadClient = client?.getChatThreadClient(e.threadId);
              setThreads((s) => {
                // const List = await apiServices.getChatThreadList();
                if (s.length < List.length) {
                  const customer = List.length && List.filter((item: any) => item.toChannel === e.threadId);
                  let i = customer[0].fromChannel.lastIndexOf(':');
                  let appId: string = customer[0].fromChannel.substring(i + 1, customer[0].fromChannel.length);
                  return [
                    ...s,
                    {
                      threadId: e.threadId,
                      displayName: customer[0].creator.displayName || `游客        ${touristName(customer[0].createAt)}`,
                      avatar: customer[0].creator.userAvatar,
                      chatThreadClient: chatThreadClient,
                      fromUserExtend: customer[0].fromUserExtend,
                      lastMessage: '',
                      date: moment(e.addedOn).format('LT'),
                      appId: appId,
                      ticketId: customer[0].id,
                      customerId: customer[0].creator.channelUserId,
                      displayTicketId: customer[0].displayTicketId
                    }
                  ];
                } else {
                  return s;
                }
              });
            } catch (exception) {
              analytics.trackException(exception);
            }
          }, 1000);
        });
        client.on('chatThreadDeleted', (e) => {
          console.log(e, 'chatThreadDeleted');
          clearTimeout(chatThreadDeleted);
          chatThreadDeleted = setTimeout(async () => {
            let activeThreads = sessionStorage.getItem('activeThreads');
            if (!activeThreads) {
              setHintDialogSubText(`工单已被管理员关闭`)
              setHintDialogTitle('关闭工单')
            } else {
              setHintDialogSubText(`关闭工单成功`)
              setHintDialogTitle('关闭工单')
            }

            setHideDialog(false)
            handleRemove(e.threadId);
          }, 3000);
        });
        //删除新成员
        client.on('participantsRemoved', (e) => {
          console.log(e, 'participantsRemoved');
          clearTimeout(participantsRemoved);
          participantsRemoved = setTimeout(async () => {
            let List = await apiServices.getChatThreadList();
            setThreads((data: ThreadInfo[]) => {

              const deletedLength = data.filter((item) => item.threadId === e.threadId);

              let activeThreads = sessionStorage.getItem('activeThreads');
              if (deletedLength.length > 0 && !activeThreads && List.length < data.length) {
                setHintDialogSubText(`当前工单已被管理员移交`)
                setHintDialogTitle('转交工单')
                setHideDialog(false)
              }
              return data;
            });
            loadPage();
            sessionStorage.removeItem('activeThreads');
          }, 3000);
          //新聊天创建

        });
      });
    }
  };

  const getKnowLedgeList = async () => {
    //获取知识库列表
    let getKnowLedgeList = await apiServices.getKnowLedgeBaseCategoryList();

    let listData: any = [];
    if (getKnowLedgeList && getKnowLedgeList.result) {
      getKnowLedgeList?.result.map(async (item: any, index: number) => {
        const list = await apiServices.getKnowLedgeBaseCategory(item.id);
        listData.push({
          id: item.id,
          name: `${item.name} (${list.result.length})`,
          listItem: list.result,
          createAt: item.createAt
        });
        //默认闭合
        return false;
      });


    }
    let Item = await apiServices.getItem('00000000-0000-0000-0000-000000000000');
    listData.unshift({
      //头部加入默认收藏夹内容
      name: `默认收藏夹(${Item?.result.length || '0'})`,
      description: '请输入内容',
      ParentsId: '414A950B-2DBC-4BE7-AC4D-6BE1D270C7EC',
      orderNumber: 1,
      listItem: Item?.result,
      createAt: 0,
      id: '00000000-0000-0000-0000-000000000000'
    });
    setIsBlockindex(() => {
      return listData.map((item: any) => {
        return false
      })
    });
    setTimeout(() => {
      setCategoryData(() => {
        listData.sort((a: any, b: any) => {
          if (moment(a.createAt).valueOf() - moment(b.createAt).valueOf() === 0) {
            return b.name.length - a.name.length;
          } else {
            return moment(a.createAt).valueOf() - moment(b.createAt).valueOf();
          }
        })
        return listData
      });
      setCategoryData2(() => {
        listData.sort((a: any, b: any) => {
          if (moment(a.createAt).valueOf() - moment(b.createAt).valueOf() === 0) {
            return b.name.length - a.name.length;
          } else {
            return moment(a.createAt).valueOf() - moment(b.createAt).valueOf();
          }
        })
        return listData
      });
    }, 2000)
    // }
  };
  const hideDialogPrimary = async () => {
    setHideDialog(true);
    setHintDialogSubText('');
    setHintDialogTitle('')

  }
  const AutoSave = async (text: string) => {
    // setTimeout(() => {
    apiServices.postKnowLedgeBase({
      CategroyId: '414A950B-2DBC-4BE7-AC4D-6BE1D270C7EC',
      Name: '未命名',
      ItemContent: text,
      OrderNumber: 1
    });
    setKnowledgeText('');
    getKnowLedgeList();
  };
 
  const isAuthenticated = useSelector(getIsAuthenticated);
  useEffect(() => {
    if (isAuthenticated) {
      loadPage();
      getKnowLedgeList();
    }
  }, [isAuthenticated]);

  return (
    <Stack grow className={StartScreenContainerStyle}>
      {isAuthenticated && <ChatHeader setAdminFncType={setAdminFncType} />}
      {isAuthenticated ? (
        <Stack horizontal horizontalAlign="space-between" className={StartScreenSectionStyle}>
          <Stack.Item style={{ flex: '1', width: "75%" }}>
            {
              <Stack
                horizontal
                style={{ background: '#F0F0F0', position: "relative", cursor: 'pointer', height: "0px", left: '26px', top: "16px" }}
              >
                <Icon iconName="ChevronDownMed" style={{ marginRight: '10px' }} />
                <Text style={{ color: '#201F1E', fontSize: '14px', fontWeight: 400 }}>正在接入</Text>
              </Stack>
            }
            <AccessibleTab
              id="left-accessible-tab"
              className={tabStyles}
              tabPosition="left"
              defaultActiveKey={threads[0]?.threadId}
              onTabClick={(key: string) => {
                TabClick(key);
              }}
              role="tablist"
              aria-busy="true"
              aria-label="threads list"
              applyToChildrenOnly
              component={Tabs}
            >
              {!threads?.length && (
                <TabPane
                  style={{ margin: '0', padding: '0', background: '#F5F5F5' }}
                  key="null"
                  tab={<div style={{ textAlign: 'center', width: '100%' }}>暂无接入，请等待</div>}
                >
                  <NoClient />
                </TabPane>
              )}
              {threads.length &&
                threads.map((item, index: any) => (
                  //左侧聊天tab
                  <TabPane
                    style={{ margin: '0', padding: '0'}}
                    key={item.threadId}
                    tab={
                      <Stack horizontal verticalAlign="center">
                        <Stack.Item disableShrink>
                          <Avatar
                            // 鼠标悬浮时展示游客（头像）
                            name="游客"
                            image={item.avatar}
                            style={{ marginRight: '10px', position: 'relative', width: '33px', height: '33px' }}
                          />
                        </Stack.Item>
                        {/* 未读消息标识 */}
                        {item.threadId === lastMessage?.threadId && item.threadId !== activeIndex && chatActive && (
                          <Status state="error" styles={chatAvatarStyle(chatActive)} />
                        )}
                        <Stack grow horizontalAlign="start" style={{ flex: '1', width: '83%' }}>
                          <Stack horizontal horizontalAlign="space-between" style={{ width: 'calc(100%)' }}>
                            <span style={{ fontWeight: 'bold', marginRight: '14px', fontSize: '14px' }}>
                              {item.displayName ? item.displayName : '游客'}
                            </span>
                            <span style={{ fontSize: '12px', position: 'absolute', top: '15px', right: '10px' }}>
                              {item.threadId === lastMessage?.threadId ? lastMessage.date : item.date}
                            </span>
                          </Stack>
                          <span
                            style={{
                              fontSize: '12px',
                              width: 'calc(100% - 35px)',
                              textAlign: 'left',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            {item.threadId === lastMessage?.threadId ? lastMessage.message : ''}
                          </span>
                        </Stack>
                      </Stack>
                    }
                  >
                    {threads.length > 0 ? (
                      <ChatArea
                        isScroll={
                          item.threadId === lastMessage?.threadId && item.threadId !== activeIndex && chatActive
                        }
                        fromUserExtend={item.fromUserExtend}
                        threadId={item.threadId}
                        threadClient={item.chatThreadClient}
                        avatar={item.avatar}
                        user={item.displayName}
                        appId={item.appId}
                        displayTicketId={item.displayTicketId}
                        ticketId={item.ticketId}
                        customerId={item.customerId}
                        isInvolved={false}
                        handleRemove={handleRemove}
                      />
                    ) : (
                      <NoClient />
                    )}
                  </TabPane>
                ))}
              {threads2.length && (
                <TabPane
                  style={{ margin: '0', padding: '0' }}
                  key="title"
                  tab={
                    <Stack horizontal style={{}}>
                      <Icon iconName="ChevronDownMed" style={{ marginRight: '10px' }} />
                      <Text style={{ color: '#201F1E', fontSize: '14px', fontWeight: 400 }}>管理员介入</Text>
                    </Stack>
                  }
                >
                  {/* <NoClient /> */}
                </TabPane>
              )}
              {threads2.length &&
                threads2.map((item, index: any) => (
                  //左侧聊天tab
                  <TabPane
                    style={{ margin: '0', padding: '0' }}
                    key={item.threadId}
                    tab={
                      <Stack horizontal verticalAlign="center" style={{ width: '260px', margin: '0px' }}>
                        <Stack.Item disableShrink>
                          <Avatar
                            // 鼠标悬浮时展示游客（头像）
                            name="游客"
                            image={item.avatar}
                            style={{ marginRight: '10px', position: 'relative', width: '33px', height: '33px' }}
                          />
                        </Stack.Item>
                        {/* 未读消息标识 */}
                        {item.threadId === lastMessage?.threadId && item.threadId !== activeIndex && chatActive && (
                          <Status state="error" styles={chatAvatarStyle(chatActive)} />
                        )}
                        <Stack grow horizontalAlign="start" style={{ flex: '1', width: '83%' }}>
                          <Stack horizontal horizontalAlign="space-between" style={{ width: 'calc(100%)' }}>
                            <span style={{ fontWeight: 'bold', marginRight: '14px', fontSize: '14px' }}>
                              {item.displayName ? item.displayName : '游客'}
                            </span>
                            <span style={{ fontSize: '12px', position: 'absolute', top: '15px', right: '10px' }}>
                              {item.threadId === lastMessage?.threadId ? lastMessage.date : item.date}
                            </span>
                          </Stack>
                          <span
                            style={{
                              fontSize: '12px',
                              width: 'calc(100% - 35px)',
                              textAlign: 'left',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            {item.threadId === lastMessage?.threadId ? lastMessage.message : ''}
                          </span>
                        </Stack>
                      </Stack>
                    }
                  >
                    {threads2.length > 0 ? (
                      <ChatArea
                        isScroll={
                          item.threadId === lastMessage?.threadId && item.threadId !== activeIndex && chatActive
                        }
                        threadId={item.threadId}
                        fromUserExtend={item.fromUserExtend}
                        threadClient={item.chatThreadClient}
                        avatar={item.avatar}
                        user={item.displayName}
                        appId={item.appId}
                        displayTicketId={item.displayTicketId}
                        ticketId={item.ticketId}
                        isInvolved={true}
                        customerId={item.customerId}
                        handleRemove={handleRemove}
                      />
                    ) : (
                      <NoClient />
                    )}
                  </TabPane>
                ))}
            </AccessibleTab>

          </Stack.Item>
          <Stack.Item className={SideboxStyles}>
            <Stack horizontal horizontalAlign="space-between" verticalAlign="center" className={SideHeaderSerchStyle}>
              <Stack horizontal verticalAlign="center" onClick={() => setHandlesearch(!handleSearch)}>
                <Icon iconName="OEM" style={{ fontSize: '20px', color: '#212121' }} />
                <Text
                  style={{
                    margin: '0px 20px 0px 12px',
                    width: '58px',
                    fontWeight: 'bold',
                    fontSize: '18px',
                    color: '#201F1E'
                  }}
                >
                  知识库
                </Text>
              </Stack>
              {handleSearch ? (
                <SearchIcon onClick={() => setHandlesearch(false)} />
              ) : (
                <Input
                  inverted
                  fluid
                  style={{ zIndex: 0 }}
                  icon={<SearchIcon />}
                  placeholder="搜索"
                  onChange={(e) => {
                    handleSearchValue(e);
                  }}
                />
              )}
            </Stack>
            <Stack grow style={{ minWidth: "200px", height: '494px', maxHeight: '90%', overflow: 'auto' }}>
              {
                <>
                  {categoryData2 && categoryData2.length > 0 ? (
                    categoryData2.map((item: any, index: number) => {
                      return (
                        <div key={index}>
                          <Stack
                            horizontal
                            horizontalAlign="start"
                            verticalAlign="center"
                            className={textHeaderStyle}
                            key={item.id}
                            onClick={() => handleList(index)}
                          >
                            {isBlockindex[index] ? (
                              <ChevronDownIcon style={{ marginRight: '16px' }} /> //展开标识
                            ) : (
                              <ChevronEndMediumIcon style={{ marginRight: '16px' }} /> //闭合标识
                            )}
                            <Text variant="large" style={{ fontSize: '14px', color: '#201F1E', fontWeight: 600 }}>
                              {item.name}
                            </Text>
                          </Stack>
                          {isBlockindex[index] && (
                            <ul style={{ padding: '0', margin: '0' }}>
                              {item.listItem &&
                                item.listItem.length > 0 &&
                                item.listItem.map((v: any) => {
                                  return (
                                    <li className={listLiStyle} key={v.id}>
                                      <Stack horizontal horizontalAlign="space-between" style={{ marginBottom: '8px', height: "24px" }}>
                                        <Text variant="xLarge" className={textStyle}>
                                          {v.name}
                                        </Text>
                                        <div className='CopyIcon' style={{ display: "none" }}>
                                          <Icon
                                            iconName={isCopythis === v.id ? 'CheckMark' : 'Copy'}
                                            className={listcopybtnStyle}
                                            onClick={() => copyContent(v.id)}
                                          />
                                        </div>
                                      </Stack>
                                      <Text variant="medium" className={mt} id={v && v.id}>
                                        {v.itemContent}
                                      </Text>
                                    </li>
                                  );
                                })}
                            </ul>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <div style={{ textAlign: 'center', width: '100%' }}>暂无数据，请等待</div>
                  )}
                </>
              }
            </Stack>
            <TextField
              className={quickSaveStyle}
              value={knowledgeText}
              multiline
              autoAdjustHeight
              onBlur={() => { setPlaceholderText(' 输入文字，快捷保存新知识') }}
              onFocus={() => { setPlaceholderText('提示：Shift+回车为换行，回车为保存') }}
              placeholder={placeholderText}
              onKeyUp={(ev) => {
                if (ev.which === ENTER_KEY && !ev.shiftKey) {
                  AutoSave(knowledgeText);
                }
              }}
              onChange={(e: any) => {
                setKnowledgeText(e.target.value);
              }}
            />
          </Stack.Item>
        </Stack>
      ) : (
        <div
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Image {...imageProps} alt="欢迎来到在线客服" />
          <p style={{ fontWeight: 600, fontSize: '18px' }}>欢迎来到在线客服</p>
        </div>
      )}
      <Modal
        titleAriaId={'title'}
        isOpen={adminFncType}
        onDismiss={() => { }}
        isBlocking={false}
        topOffsetFixed={true}
        containerClassName={
          adminFncType === 2 || adminFncType === 4
            ? contentStyles.containerLogPage
            : adminFncType === 1
              ? contentStyles.containerMonitor
              : contentStyles.SetupPage
        }
        styles={{ root: { width: "100%" } }}
      >
        <div className={contentStyles.header}>
          <IconButton
            styles={iconButtonStyles}
            iconProps={cancelIcon}
            ariaLabel="Close popup modal"
            onClick={() => {
              setAdminFncType(0);
            }}
          />
        </div>
        <div className={contentStyles.body}>
          {adminFncType === 1 ? (
            <Monitor loadPage={loadPage} handleRemove={handleRemove} setAdminFncType={setAdminFncType} />
          ) : (
            ''
          )}
          {adminFncType === 2 ? <LogPage /> : ''}
          {adminFncType === 3 ? <SetupPage /> : ''}
          {adminFncType === 4 ? <PersonalLogPage /> : ''}
        </div>
      </Modal>
      {HintDialogTitle && HintDialogSubText &&
        <Dialog
          hidden={hideDialog}
          type={DialogType.normal}
          title={HintDialogTitle}
          subText={HintDialogSubText}
          onDismiss={() => { setIsDraggable(false) }}
          // dialogContentProps={dialogContentProps}
          modalProps={modalProps}
        >
          <DialogFooter>
            <PrimaryButton onClick={() => { hideDialogPrimary() }} text="确定" />
          </DialogFooter>
        </Dialog>
      }
    </Stack>
  );
}
